<template>
  <Loader :loading="httpSend">
    <div class="col-xl-12">
      <h5 class="mb-3 mt-3">1 - Tributável no Município</h5>
      <div v-if="notas.no_municipio && notas.no_municipio.length > 0" class="table-responsive">
        <table class="table table-striped mb-0">
          <thead>
          <tr>
            <th class="border-top-0">Número</th>
            <th class="border-top-0">Tomador</th>
            <th class="text-center border-top-0">Tipo de serviço</th>
            <th class="text-center border-top-0">Alíquota</th>
            <th class="text-right border-top-0">Valor Deduções</th>
            <th class="text-right border-top-0">Base de cálculo</th>
            <th class="text-right border-top-0">ISS</th>
            <th class="text-center border-top-0">Exigibilidade ISS</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="n in notas.no_municipio" :key="n.not_numero">
            <td>
              <router-link
                  tag="a"
                  target="_blank"
                  :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: n.not_hash}}">
                {{ n.not_numero }}
              </router-link>
            </td>
            <td>{{ n.sep_razao_social_tomador }}</td>
            <td class="text-center">{{ n.ser_codigo }}</td>
            <td class="text-center">{{ n.sep_aliquota | formatPorcentagemBr }}</td>
            <td class="text-right">{{ n.sep_deducoes | formatNumeroBr }}</td>
            <td class="text-right">{{ n.not_base_calculo | formatNumeroBr }}</td>
            <td class="text-right">{{ n.sep_iss | formatNumeroBr }}</td>
            <td class="text-center">{{ n.sep_exigibilidade_iss | exigibilidadeIss }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="4"></td>
            <td class="text-right">{{ deducoes_no_municipio | formatNumeroBr }}</td>
            <td class="text-right">{{ base_no_municipio | formatNumeroBr }}</td>
            <td class="text-right">{{ iss_no_municipio | formatNumeroBr }}</td>
            <td class="text-center"></td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-sm-12">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-warning">
              <i class="mdi mdi-alert-outline mr-2"></i> Não foi localizada nenhuma NFS-e para o período de apuração
              informado
            </div>
          </div>
        </div>
      </div>
      <h5 class="mb-3 mt-3">2 - Tributável com ISS Retido na Fonte</h5>
      <div v-if="notas.retido && notas.retido.length > 0" class="table-responsive">
        <table class="table table-striped mb-0">
          <thead>
          <tr>
            <th class="border-top-0">Número</th>
            <th class="border-top-0">Tomador</th>
            <th class="text-center border-top-0">Tipo de serviço</th>
            <th class="text-center border-top-0">Alíquota</th>
            <th class="text-right border-top-0">Valor Deduções</th>
            <th class="text-right border-top-0">Base de cálculo</th>
            <th class="text-right border-top-0">ISS</th>
            <th class="text-center border-top-0">Exigibilidade ISS</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="n in notas.retido" :key="n.not_numero">
            <td>
              <router-link
                  tag="a"
                  target="_blank"
                  :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: n.not_hash}}">
                {{ n.not_numero }}
              </router-link>
            </td>
            <td>{{ n.sep_razao_social_tomador }}</td>
            <td class="text-center">{{ n.ser_codigo }}</td>
            <td class="text-center">{{ n.sep_aliquota | formatPorcentagemBr }}</td>
            <td class="text-right">{{ n.sep_deducoes | formatNumeroBr }}</td>
            <td class="text-right">{{ n.not_base_calculo | formatNumeroBr }}</td>
            <td class="text-right">{{ n.sep_iss | formatNumeroBr }}</td>
            <td class="text-center">{{ n.mun_nome +' - '+ n.mun_uf}}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="4"></td>
            <td class="text-right">{{ deducoes_retido | formatNumeroBr }}</td>
            <td class="text-right">{{ base_retido | formatNumeroBr }}</td>
            <td class="text-right">{{ iss_retido | formatNumeroBr }}</td>
            <td class="text-center"></td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-sm-12">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-warning">
              <i class="mdi mdi-alert-outline mr-2"></i> Não foi localizada nenhuma NFS-e para o período de apuração
              informado
            </div>
          </div>
        </div>
      </div>
      <h5 class="mb-3 mt-3">3 - Tributação fora do Município</h5>
      <div v-if="notas.fora_municipio && notas.fora_municipio.length > 0" class="table-responsive">
        <table class="table table-striped mb-0">
          <thead>
          <tr>
            <th class="border-top-0">Número</th>
            <th class="border-top-0">Tomador</th>
            <th class="text-center border-top-0">Tipo de serviço</th>
            <th class="text-center border-top-0">Alíquota</th>
            <th class="text-right border-top-0">Valor Deduções</th>
            <th class="text-right border-top-0">Base de cálculo</th>
            <th class="text-right border-top-0">ISS</th>
            <th class="text-center border-top-0">Exigibilidade ISS</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="n in notas.fora_municipio" :key="n.not_numero">
            <td>
              <router-link
                  tag="a"
                  target="_blank"
                  :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: n.not_hash}}">
                {{ n.not_numero }}
              </router-link>
            </td>
            <td>{{ n.sep_razao_social_tomador }}</td>
            <td class="text-center">{{ n.ser_codigo }}</td>
            <td class="text-center">{{ n.sep_aliquota | formatPorcentagemBr }}</td>
            <td class="text-right">{{ n.sep_deducoes | formatNumeroBr }}</td>
            <td class="text-right">{{ n.not_base_calculo | formatNumeroBr }}</td>
            <td class="text-right">{{ n.sep_iss | formatNumeroBr }}</td>
            <td class="text-center">{{ n.mun_nome +' - '+ n.mun_uf}}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="4"></td>
            <td class="text-right">{{ deducoes_fora_municipio | formatNumeroBr }}</td>
            <td class="text-right">{{ base_fora_municipio | formatNumeroBr }}</td>
            <td class="text-right">{{ iss_fora_municipio | formatNumeroBr }}</td>
            <td class="text-center"></td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-sm-12">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-warning">
              <i class="mdi mdi-alert-outline mr-2"></i> Não foi localizada nenhuma NFS-e para o período de apuração
              informado
            </div>
          </div>
        </div>
      </div>
      <h5 class="mb-3 mt-3"> 4.1 - Não Tributável sobre Faturamento (ISS Fixo)</h5>
      <div v-if="notas.nao_tributavel_sobre_faturamento && notas.nao_tributavel_sobre_faturamento.length > 0" class="table-responsive">
        <table class="table table-striped mb-0">
          <thead>
          <tr>
            <th class="border-top-0">Número</th>
            <th class="border-top-0">Tomador</th>
            <th class="text-center border-top-0">Tipo de serviço</th>
            <th class="text-center border-top-0">Alíquota</th>
            <th class="text-right border-top-0">Valor Deduções</th>
            <th class="text-right border-top-0">Base de cálculo</th>
            <th class="text-right border-top-0">ISS</th>
            <th class="text-center border-top-0">Exigibilidade ISS</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="n in notas.nao_tributavel_sobre_faturamento" :key="n.not_numero">
            <td>
              <router-link
                  tag="a"
                  target="_blank"
                  :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: n.not_hash}}">
                {{ n.not_numero }}
              </router-link>
            </td>
            <td>{{ n.sep_razao_social_tomador }}</td>
            <td class="text-center">{{ n.ser_codigo }}</td>
            <td class="text-center">{{ n.sep_aliquota | formatPorcentagemBr }}</td>
            <td class="text-right">{{ n.sep_deducoes | formatNumeroBr }}</td>
            <td class="text-right">{{ n.not_base_calculo | formatNumeroBr }}</td>
            <td class="text-right">{{ n.sep_iss | formatNumeroBr }}</td>
            <td class="text-center">{{ n.sep_exigibilidade_iss | exigibilidadeIss }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="4"></td>
            <td class="text-right">{{ deducoes_nao_tributavel_sobre_faturamento | formatNumeroBr }}</td>
            <td class="text-right">{{ base_nao_tributavel_sobre_faturamento | formatNumeroBr }}</td>
            <td class="text-right">{{ iss_nao_tributavel_sobre_faturamento | formatNumeroBr }}</td>
            <td class="text-center"></td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-sm-12">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-warning">
              <i class="mdi mdi-alert-outline mr-2"></i> Não foi localizada nenhuma NFS-e para o período de apuração
              informado
            </div>
          </div>
        </div>
      </div>
      <h5 class="mb-3 mt-3">4.2 - Não Sujeito a ISS, Isento, Imune ou com Exigibilidade Suspensa</h5>
      <div v-if="notas.nao_sujeito_iss && notas.nao_sujeito_iss.length > 0" class="table-responsive">
        <table class="table table-striped mb-0">
          <thead>
          <tr>
            <th class="border-top-0">Número</th>
            <th class="border-top-0">Tomador</th>
            <th class="text-center border-top-0">Tipo de serviço</th>
            <th class="text-center border-top-0">Alíquota</th>
            <th class="text-right border-top-0">Valor Deduções</th>
            <th class="text-right border-top-0">Base de cálculo</th>
            <th class="text-right border-top-0">ISS</th>
            <th class="text-center border-top-0">Exigibilidade ISS</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="n in notas.nao_sujeito_iss" :key="n.not_numero">
            <td>
              <router-link
                  tag="a"
                  target="_blank"
                  :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: n.not_hash}}">
                {{ n.not_numero }}
              </router-link>
            </td>
            <td>{{ n.sep_razao_social_tomador }}</td>
            <td class="text-center">{{ n.ser_codigo }}</td>
            <td class="text-center">{{ n.sep_aliquota | formatPorcentagemBr }}</td>
            <td class="text-right">{{ n.sep_deducoes | formatNumeroBr }}</td>
            <td class="text-right">{{ n.not_base_calculo | formatNumeroBr }}</td>
            <td class="text-right">{{ n.sep_iss | formatNumeroBr }}</td>
            <td class="text-center">{{ n.sep_exigibilidade_iss | exigibilidadeIss }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="4"></td>
            <td class="text-right">{{ deducoes_nao_sujeito_iss | formatNumeroBr }}</td>
            <td class="text-right">{{ base_nao_sujeito_iss | formatNumeroBr }}</td>
            <td class="text-right">{{ iss_nao_sujeito_iss | formatNumeroBr }}</td>
            <td class="text-center"></td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-sm-12">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-warning">
              <i class="mdi mdi-alert-outline mr-2"></i> Não foi localizada nenhuma NFS-e para o período de apuração
              informado
            </div>
          </div>
        </div>
      </div>
    </div>
  </Loader>
</template>

<script>
import Loader from "@/components/widgets/loader";
import {listNotasSimples} from "@/api/nfse/nota";

export default {
  name: "simplesNfse",
  components: {
    Loader,
  },
  props: {
    eco_codigo: {
      type: String,
      required: true,
    },
    competencia: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      httpSend: false,
      notas: {
        no_municipio: [],
        fora_municipio: [],
        retido: [],
        nao_tributavel_sobre_faturamento: [],
        nao_sujeito_iss: []
      }
    };
  },
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
    deducoes_no_municipio: {
      get: function () {
        return this.notas.no_municipio
            .map(p => Number(p.sep_deducoes))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    base_no_municipio: {
      get: function () {
        return this.notas.no_municipio
            .map(p => Number(p.not_base_calculo))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    iss_no_municipio: {
      get: function () {
        return this.notas.no_municipio
            .map(p => Number(p.sep_iss))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    deducoes_fora_municipio: {
      get: function () {
        return this.notas.fora_municipio
            .map(p => Number(p.sep_deducoes))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    base_fora_municipio: {
      get: function () {
        return this.notas.fora_municipio
            .map(p => Number(p.not_base_calculo))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    iss_fora_municipio: {
      get: function () {
        return this.notas.fora_municipio
            .map(p => Number(p.sep_iss))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    deducoes_retido: {
      get: function () {
        return this.notas.retido
            .map(p => Number(p.sep_deducoes))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    base_retido: {
      get: function () {
        return this.notas.retido
            .map(p => Number(p.not_base_calculo))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    iss_retido: {
      get: function () {
        return this.notas.retido
            .map(p => Number(p.sep_iss))
            .reduce((sum, current) => sum + current, 0);
      }
    },

    deducoes_nao_tributavel_sobre_faturamento: {
      get: function () {
        return this.notas.nao_tributavel_sobre_faturamento
            .map(p => Number(p.sep_deducoes))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    base_nao_tributavel_sobre_faturamento: {
      get: function () {
        return this.notas.nao_tributavel_sobre_faturamento
            .map(p => Number(p.not_base_calculo))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    iss_nao_tributavel_sobre_faturamento: {
      get: function () {
        return this.notas.nao_sujeito_iss
            .map(p => Number(p.sep_iss))
            .reduce((sum, current) => sum + current, 0);
      }
    },

    deducoes_nao_sujeito_iss: {
      get: function () {
        return this.notas.nao_sujeito_iss
            .map(p => Number(p.sep_deducoes))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    base_nao_sujeito_iss: {
      get: function () {
        return this.notas.nao_sujeito_iss
            .map(p => Number(p.not_base_calculo))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    iss_nao_sujeito_iss: {
      get: function () {
        return this.notas.nao_sujeito_iss
            .map(p => Number(p.sep_iss))
            .reduce((sum, current) => sum + current, 0);
      }
    }
  },
  methods: {
    list_notas_simples() {
      this.httpSend = true;
      listNotasSimples(this.eco_codigo, this.competencia).then(result => {
        this.notas.no_municipio = result.dados.no_municipio;
        this.notas.fora_municipio = result.dados.fora_municipio;
        this.notas.retido = result.dados.retido;
        this.notas.nao_tributavel_sobre_faturamento = result.dados.nao_tributavel_sobre_faturamento;
        this.notas.nao_sujeito_iss = result.dados.nao_sujeito_iss;
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
}
</script>

<style scoped>

</style>
